import { TeamPlanTier } from "@alch/dx-entities";

const PAYG_PLANS = [
  TeamPlanTier.FREE,
  TeamPlanTier.PAYG,
  TeamPlanTier.ENTERPRISE,
];

const useAvailablePlanTiers = () => {
  return PAYG_PLANS;
};

export default useAvailablePlanTiers;
